import { enumerate } from '/lib/utils';

// eslint-disable-next-line import/prefer-default-export
export const TYPE = enumerate('QA', 'FAQ', 'INTERVIEW', 'CUSTOM');
